import { usePendencias } from "@/contexts/pendencias-context";
import { isRouteActive } from "@/utils/route";
import { AlertTriangle } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { menuItems } from "./nav-items";

export default function MobileTabs() {
  const { pathname } = useLocation();
  const { getSidebarAlerts } = usePendencias();
  const sidebarAlerts = getSidebarAlerts();

  return (
    <nav
      className="
        lg:hidden fixed bottom-0 left-0 right-0 z-50
        bg-white border-t border-gray-200
        h-16 px-2 flex items-center justify-between
        pb-[env(safe-area-inset-bottom)]
      "
    >
      {menuItems.map((item) => {
        const active = isRouteActive(pathname, item.to, true);
        const hasAlert = !!sidebarAlerts[item.id];

        return (
          <Link
            key={item.to}
            to={item.to}
            className="relative flex flex-col items-center justify-center flex-1"
          >
            <div
              className={`flex items-center justify-center p-3 rounded-md ${
                active ? "bg-n-green-h-light" : ""
              }`}
            >
              {item.icon}
            </div>
            {hasAlert && (
              <div className="absolute top-1 right-1">
                <AlertTriangle className="w-3 h-3 text-red-600" />
              </div>
            )}
          </Link>
        );
      })}
    </nav>
  );
}
